import { useQuery } from 'hooks/useCustomQuery';
import getOutboundCaller from '@/API/Company/getOutboundCaller';

const useGetOutboundCaller = (currentCompany, enabled = true) => {
    return useQuery({
        queryKey: ['outboundCaller'],
        queryFn: () => getOutboundCaller(currentCompany),
        select: (res = []) => [
            ...res,
            {
                id: 'Restricted',
                telephoneNumber: 'Restricted',
                cliPresentation: 'Restricted',
            },
        ],
        refetchOnWindowFocus: false,
        staleTime: 10 * 60 * 1000, // 10 minutes
        enabled,
    });
};

export default useGetOutboundCaller;
